import styled from '@emotion/styled';
import { useRef, useContext } from 'react';
import { useFocusRing, useRadio, VisuallyHidden, mergeProps } from 'react-aria';

import { mergeRefs } from '../../../lib/mergeRefs';
import { Glyph } from '../../common/Glyph';
import { RoundIconWrapper } from '../../common/RoundIconWrapper';

import { su } from '../../../theme/functions/su';
import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';

import { RadioContext } from './RadioGroup';

const iconMap = {
  boolean: {
    source: glyph.logic.boolean,
    color: theme.color.logic_boolean,
  },
  number: {
    source: glyph.logic.number,
    color: theme.color.logic_number,
  },
  string: {
    source: glyph.logic.string,
    color: theme.color.logic_string,
  },
};

export function TypeRadio(props) {
  const context = useContext(RadioContext);

  const { ref: registerRef, ...registerProps } =
    context.register?.(context.name, {
      required: props.required,
    }) ?? {};

  const radioRef = useRef();
  const radio = useRadio(props, context.state, radioRef);
  const focusRing = useFocusRing();

  const isSelected = context.state.selectedValue === props.value;

  return (
    <S.Label data-is-selected={isSelected}>
      <VisuallyHidden>
        <input
          {...mergeProps(radio.inputProps, focusRing.focusProps, registerProps)}
          ref={mergeRefs([registerRef, radioRef])}
        />
      </VisuallyHidden>

      <RoundIconWrapper size={theme.icon.size_large} color={iconMap[props.type].color}>
        <Glyph
          size={theme.icon.size_medium}
          source={iconMap[props.type].source}
          color={theme.color.icon_white}
        />
      </RoundIconWrapper>
      <S.Name>{props.children}</S.Name>
    </S.Label>
  );
}

function S() {}
TypeRadio.S = S;

S.Label = styled.label`
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  font-weight: normal;
  align-items: center;
  padding: ${su(1)};
  border-radius: ${theme.borderRadius.default};
  cursor: pointer;
  margin: 0;
  border: 1px solid transparent;

  &[data-is-selected='true'] {
    background-color: ${theme.color.highlight_background};
    border: 1px solid ${theme.color.highlight_border};
  }
`;

S.Name = styled.span`
  display: inline-block;
  margin-top: ${su(1)};
`;
